/* eslint-disable max-len */
import React from 'react';
import UpdateDocument from '../../../UpdateDocument';
import InputField from '../../../InputFeld';
import { HandleInputChange } from '../../../InputFeld/inputChange';
import ViewSkeleton from '../Shimmers/ViewSkeleton';

const UpdateProfile = ({
    setUpdateDocumentSate, 
    updateDocumentSate, 
    updateDocumentError, 
    setUpdateDocumentError,
    formatError,
    setformatError,
    submitSelected,
    setsubmitSelected,
    Type,
    customError,
    setcustomError
}) => {

    return (
        <>
            <UpdateDocument 
                title={`Update ${Type} Information`} 
                customError={customError}
                state={updateDocumentSate} 
                setstate={setUpdateDocumentSate} 
                error={updateDocumentError}
                setError={setUpdateDocumentError}
                formatError={formatError}
                setformatError={setformatError}
                setcustomError={setcustomError}
                mainKey={Type.toLowerCase()}
                submitSelected={submitSelected}
                setsubmitSelected={setsubmitSelected}
            />
        </>
        
    );
}

export default UpdateProfile;
